function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup59644(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 59644",
    transform: "translate(-1509 -1458)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 2524",
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    transform: "translate(1509 1458)",
    style: {
      fill: "#612166"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "bubble-chat (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29792",
    d: "M19.555 32.959A13.336 13.336 0 0 0 12.568 31C5.74 31 0 36.087 0 42.6a10.889 10.889 0 0 0 2.057 6.364L.175 54.876a.967.967 0 0 0 1.359 1.155l5.725-2.911q.348.15.7.279a12.775 12.775 0 0 1-2.029-6.93c0-7.406 6.231-13.099 13.625-13.51z",
    transform: "translate(1531 1451)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29793",
    d: "M145.079 108.966a10.889 10.889 0 0 0 2.057-6.364c0-6.516-5.742-11.6-12.568-11.6S122 96.087 122 102.6s5.742 11.6 12.568 11.6a13.522 13.522 0 0 0 5.309-1.083l5.726 2.911a.967.967 0 0 0 1.359-1.155zm-14.443-5.4a.967.967 0 1 1 .967-.967.967.967 0 0 1-.966.969zm3.867 0a.967.967 0 1 1 .967-.967.967.967 0 0 1-.97.969zm3.867 0a.967.967 0 1 1 .967-.967.967.967 0 0 1-.966.969z",
    transform: "translate(1416.863 1394.867)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup59644);
export default __webpack_public_path__ + "static/media/Group 59644.93e6fbb635111625a1b8d6d0195c01ad.svg";
export { ForwardRef as ReactComponent };